//for user
export const SET_USER_NAME = "SET_USER_NAME";
export const SET_AGE = "SET_AGE";

//for math
export const ADD = "ADD";
export const SUBTRACT = "SUBTRACT";

//for ui
export const TOGGLE_LEFT_DRAWER = "TOGGLE_LEFT_DRAWER";
export const TOGGLE_SNACK_BAR = "TOGGLE_SNACK_BAR";
export const TOGGLE_LOADING_GLOBAL = "TOGGLE_LOADING_GLOBAL";
export const TOGGLE_LOCK_MENU = "TOGGLE_LOCK_MENU";



//for saga

export const LOGIN = "LOGIN";
export const GET_UNITS = "GET_UNITS";
export const GET_UNITS_SUCCESS = "GET_UNITS_SUCCESS";
export const SET_USER = "SET_USER";
export const GET_USERS = "GET_USERS";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_BYNAME  = "GET_USERS_BYNAME";
export const GET_USERS_BYNAME_SUCCESS  = "GET_USERS_BYNAME_SUCCESS";
export const GET_SISWA = "GET_SISWA";
export const GET_SISWA_SUCCESS = "GET_SISWA_SUCCESS";
export const GET_SURVEYS = "GET_SURVEYS";
export const GET_SURVEY_SUCCESS = "GET_SURVEY_SUCCESS";
export const ADD_SURVEY  = "ADD_SURVEY";
export const UPDATE_SURVEY  = "UPDATE_SURVEY";
export const GET_QUESTIONS = "GET_QUESTIONS";
export const GET_QUESTION_SUCCESS = "GET_QUESTION_SUCCESS";
export const GET_QUESTIONS_BYGROUP = "GET_QUESTIONS_BYGROUP";
export const GET_QUESTIONS_BYGROUP_SUCCESS = "GET_QUESTIONS_BYGROUP_SUCCESS";
export const GET_QUESTION_GROUPS = "GET_QUESTION_GROUPS";
export const GET_GROUP_SUCCESS = "GET_GROUP_SUCCESS";
export const GET_SURVEY_TASKS = "GET_SURVEY_TASKS";
export const GET_SURVEY_SELECT = "GET_SURVEY_SELECT";
export const GET_SURVEY_SELECT_SUCCESS = "GET_SURVEY_SELECT_SUCCESS";
export const GET_1SURVEY = "GET_1SURVEY";
export const GET_1SURVEY_SUCCESS = "GET_1SURVEY_SUCCESS";
export const GET_SURVEY_TASK_SUCCESS = "GET_SURVEY_TASK_SUCCESS";
export const GET_SURVEY_TASK_DETAIL_SUCCESS = "GET_SURVEY_TASK_DETAIL_SUCCESS";
export const GET_SURVEY_TASK_DETAIL  = "GET_SURVEY_TASK_DETAIL";
export const GET_SURVEY_TITTLE_SUCCESS  = "GET_SURVEY_TITTLE_SUCCESS";
export const GET_SURVEY_TITTLE   = "GET_SURVEY_TITTLE";
export const GET_EMP_OWNER_BYSRV   = "GET_EMP_OWNER_BYSRV";
export const GET_EMP_OWNER_BYSRV_SUCCESS   = "GET_EMP_OWNER_BYSRV_SUCCESS";
export const GET_UNIT_OWNER_BYSRV   = "GET_UNIT_OWNER_BYSRV";
export const GET_UNIT_OWNER_BYSRV_SUCCESS   = "GET_UNIT_OWNER_BYSRV_SUCCESS";
export const GET_SURVEYOR_BYSRV   = "GET_SURVEYOR_BYSRV";
export const GET_SURVEYOR_BYSRV_SUCCESS   = "GET_SURVEYOR_BYSRV_SUCCESS";
export const GET_ANSWER_SURVEYOR   = "GET_ANSWER_SURVEYOR";
export const GET_ANSWER_SURVEYOR_SUCCESS   = "GET_ANSWER_SURVEYOR_SUCCESS";
export const GET_CRNT_SRV_IMPL   = "GET_CRNT_SRV_IMPL";
export const GET_CRNT_SRV_IMPL_SUCCESS   = "GET_CRNT_SRV_IMPL_SUCCESS";
export const SAVE_SURVEY_ANSWER = "SAVE_SURVEY_ANSWER";
export const ADD_QUESTION_GROUP  = "ADD_QUESTION_GROUP";
export const ADD_QUESTION  = "ADD_QUESTION";
export const DELETE_QUESTION  = "DELETE_QUESTION";
export const RESET_CURRENT_SURVEY  = "RESET_CURRENT_SURVEY";









